import {computed, defineComponent} from 'vue';
import {type PaymentSession} from "@/api/enterprise-gateway-api.proxy.ts";
import {useFormatting} from "@/composables/currency-format.ts";

export default defineComponent({
    name: 'AegProductLines',
    props: {
        paymentSession: {
            type: Object as () => PaymentSession,
            required: true,
        },
    },
    setup(props) {
        const {formatCurrency} = useFormatting();

        const productLines = computed(() => {
            return props.paymentSession.productLines;
        })

        return {
            productLines,
            formatCurrency
        }
    }
})
